import {useEffect, useState} from "react";
import {BridgeConfig, BridgeToken, getConfig, getTokens} from "../api/bridge";

export const useBridgeData = () => {
  const [isLoading, setLoading] = useState(false);
  const [config, setConfig] = useState<BridgeConfig>();
  const [tokens, setTokens] = useState<BridgeToken[]>([]);

  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true)
        const [configData, tokensData] = await Promise.all([getConfig(), getTokens()])
        setConfig(configData)
        setTokens(tokensData)
      } catch(e) {
        console.error('Failed to load bridge data', e)
      } finally {
        setLoading(false)
      }
    }
    loadData()
  }, []);

  return {
    isLoading,
    config,
    tokens
  }
}
